export default "__VITE_ASSET__DDVbE_Ht__"